<template>
  <transition name="fade">
    <section class="cookie-notification cookie" v-if="show">
      <div class="cookie__container">
        <p class="cookie__text">
          Настоящий Сайт использует файлы cookie и собирает сведения о пользователях сайта в целях 
          анализа эффективности и улучшения работы сервисов сайта. Обработка сведений о пользователях 
          сайта осуществляется в соответствии с
          <a
            href="https://avtomir.ru/disclaimer/politic/"
            target="_blank"
            rel="noopener"
            class="cookie__link"
          >
            Политикой в отношении обработки персональных данных.
          </a>
          Если Вы продолжите пользоваться нашими услугами, мы будем считать, что Вы согласны с 
          использованием cookie-файлов. Или Вы можете запретить сохранение cookie в настройках 
          своего браузера.
        </p>

        <button class="cookie__btn" @click="close">
          Хорошо
        </button>
      </div>
    </section>
  </transition>
</template>


<script>
export default {
  name: "cookie-notification",
  data() {
    return {
      show: false,
    };
  },
  computed: {
    cookieExpire(){
      // const days = 365  // через сколько дней снова показывать сообщение о cookie
      // return days * 24 * 60 * 60 // количество дней в секундах
    },
  },
  mounted() {
    if( !localStorage.getItem('isNotifShown') ) this.show = true
    // if( !this.getCookie('isNotifShown') ) this.show = true
  },
  methods: {
    close() {
      this.show = false
      localStorage.setItem('isNotifShown', 'true')
      // this.setCookie('isNotifShown', true)
    },

    getCookie(name) {
      let matches = document.cookie.match(new RegExp(
          "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      // возвращает куки с указанным name,
      // или undefined, если ничего не найдено
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },
    setCookie(name, value, options = {'max-age': this.cookieExpire}) {
      options = {
        path: '/',
        // при необходимости добавьте другие значения по умолчанию
        ...options
      };

      if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
      }

      let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

      for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
          updatedCookie += "=" + optionValue;
        }
      }

      document.cookie = updatedCookie;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/constants.scss";

.cookie {
  position: fixed;
  left: 0;
  bottom: 1vw;
  width: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  font-size: 12px;

  &__container {
    display: flex;
    gap: 5px;
    align-items: center;
    background-color: #000;
    color: #fff;
    box-shadow:  2px 2px 7px #555;
    padding: 1.2em;
    max-width: 50%;
  }

  &__title {
    font-size: 1.1em;
    line-height: 20px;
  }

  &__text {
    font-size: 1em;
    margin: 0;
  }

  &__link {
    color: $primary;
    text-decoration: underline;
  }

  &__btn {
    font-size: 1.1em;
    color: #ffffff;
    background-color: $primary;
    border: none;
    padding: 0.5em 2em;
    cursor: pointer;
  }
}

@media (max-width: 800px) {
  .cookie {
    font-size: 10px;
    
    &__container {
      max-width: 90%;
    }
  }
}

@media (max-width: 640px) {
  .cookie {
    display: none;
  }
}
</style>
